import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

import styles from './RevampTableRoot.module.scss';

export const RevampTableRoot = forwardRef<
  HTMLTableElement,
  ComponentPropsWithoutRef<'table'>
>(({ className, ...props }, ref) => (
  <table ref={ref} className={clsx(styles.root, className)} {...props} />
));

RevampTableRoot.displayName = 'RevampTableRoot';
